module.exports = __webpack_public_path__ + "img/WICC.1e5f0c6f.svg";